import { environment } from "./../../environments/environment";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppAuthGuard } from "../login/services/app.authguard";
import { UpdatenoticeListComponent } from "./updatenotice-list/updatenotice-list.component";
import { UpdatenoticeListProvidersComponent } from "./updatenotice-list-providers/updatenotice-list-providers.component";
import { NewUpdateNoticeComponent } from "./new-updatenotice/new-updatenotice.component";
import { ReviewUpdateNoticeComponent } from "./review-updatenotice/review-updatenotice.component";
import { EditUpdateNoticeComponent } from "./edit-updatenotice/edit-updatenotice.component";
import { DeleteUpdateNoticeComponent } from "./delete-updatenotice/delete-updatenotice.component";
import { Layouts } from "../app.component";
import { UpdateNoticeValidationHistoryComponent } from "./update-notice-validation-history/update-notice-validation-history.component";
import { UpdateNoticeValidationReportComponent } from "./update-notice-validation-report/update-notice-validation-report.component";
import { MultiPageContainerComponent } from "./multi-page-container/multi-page-container.component";
import { AisProductFormComponent } from "./ais-product-form/ais-product-form.component";
import { AisProductSelectorComponent } from "./ais-product-selector/ais-product-selector.component";
import { aisProductParamsGuard } from "./guards/ais-product-params.guard";

const UNroutes: Routes = [
  {
    path: "update",
    component: UpdatenoticeListComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "change-requests",
    component: UpdatenoticeListComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "update/new",
    component: NewUpdateNoticeComponent,
    canActivate: [AppAuthGuard],
    data: { layout: Layouts.SecureLayout, roles: [environment.roles.role_Data_Provider] },
  },
  {
    path: "updatenotice-list-providers",
    component: UpdatenoticeListProvidersComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "review-updatenotice/:id",
    component: ReviewUpdateNoticeComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "update/id/:id",
    component: EditUpdateNoticeComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "delete-updatenotice/:id",
    component: DeleteUpdateNoticeComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "change-request/:id/validation-report",
    component: UpdateNoticeValidationReportComponent,
    data: { layout: Layouts.SecureLayout },
  },
  // {
  //   path: "update-notice/:id/validation-report/:taskId",
  //   component: UpdateNoticeValidationReportComponent,
  //   data: { layout: Layouts.SecureLayout },
  // },
  {
    path: "change-request/:id/validation-history",
    component: UpdateNoticeValidationHistoryComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "change-request/new",
    component: MultiPageContainerComponent,
    canActivate: [AppAuthGuard],
    data: { layout: Layouts.SecureLayout, roles: [environment.roles.role_Data_Provider] },
    children: [
      { path: "", redirectTo: "ais-product", pathMatch: "full" },
      { path: "ais-product", component: AisProductSelectorComponent, data: { step: 1 } },
      {
        path: ":aisProduct",
        canActivate: [aisProductParamsGuard],
        component: AisProductFormComponent,
        data: { step: 2 },
      },
    ],
  },
  {
    path: "change-request/:state/:id",
    component: EditUpdateNoticeComponent,
    data: { layout: Layouts.SecureLayout },
  },
];

@NgModule({
  imports: [RouterModule.forChild(UNroutes)],
  exports: [RouterModule],
})
export class UpdateNoticeRoutingModule {}
